import React from 'react';
import MuiPagination, {PaginationProps} from '@material-ui/lab/Pagination';
import {makeStyles} from '@material-ui/core/styles';
import {lightTheme} from '@components/@theme/lightTheme';
import {PaginationItem} from '@material-ui/lab';

interface Props extends PaginationProps {
  borderless?: boolean;
}

export const Pagination: React.FC<Props> = ({borderless, ...props}) => {
  const {borderlessPagination, borderlessPaginationItem, pagination, paginationItem} =
    useStyles(lightTheme);

  if (!props.count || props.count <= 1) return null;
  return (
    <MuiPagination
      className={borderless ? borderlessPagination : pagination}
      variant={'outlined'}
      renderItem={itemProps => (
        <PaginationItem
          {...itemProps}
          className={borderless ? borderlessPaginationItem : paginationItem}
        />
      )}
      {...props}
    />
  );
};

const useStyles = makeStyles(theme => ({
  borderlessPagination: {
    '& .MuiPaginationItem-root': {
      width: 24,
      minWidth: 24,
      border: 'none',
      borderRadius: 4,
      margin: '0 1px',
    },
  },
  borderlessPaginationItem: {
    '&.Mui-selected': {
      color: theme.palette.primary.dark,
      backgroundColor: '#F0F2F5',
    },
  },
  pagination: {
    '& .MuiPaginationItem-root': {
      border: '1px solid #ccc',
      borderRadius: 0,
      margin: 0,
    },
  },
  paginationItem: {
    '&.Mui-selected': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },
}));
